import { Button, Icon } from '@gripp/shared-ui';
import { StyleSheet } from 'react-native';

interface AddButtonProps {
  onPress: () => void;
}

export const AddButton = ({ onPress }: AddButtonProps) => {
  return (
    <Button
      variant="rectangular"
      onPress={onPress}
      state="warning"
      leftIcon={<Icon name="Add" size={16} color="white" />}
      style={styles.addButton}
    />
  );
};

const styles = StyleSheet.create({
  addButton: {
    padding: 0,
    margin: 0,
    height: 40,
    width: 40,
    minHeight: 40,
    minWidth: 40,
  },
});
